import Skeleton from '@/common/helios/Skeleton';
import useKeyWithInterval from '~/hooks/common/ui/useKeyWithInterval';
import useIsPriceLoading from '~/hooks/vdp/selectors/useIsPriceLoading';
import { useVehiclePrice } from '~/hooks/vdp/useVehiclePrice';

export default function Price() {
  const isLoading = useIsPriceLoading();
  const priceKey = useKeyWithInterval();
  const { finalPrice } = useVehiclePrice();

  return isLoading ? (
    <Skeleton height={20} width={100} />
  ) : (
    <div key={priceKey}>${finalPrice.toLocaleString()}</div>
  );
}
